import { useCallback } from 'react';
import { useSetSideNavOpen } from '@customerio/pluma-components/react';
import { useOnPathChange } from '@/services/router/use-on-path-change';

/**
 * Closes the nav overlay below `lg` once a navigation lands, so a nav item doesn't
 * leave it covering the new page. Render inside the `SideNavProvider`.
 */
export function CloseSideNavOnNavigate() {
  const setSideNavOpen = useSetSideNavOpen();

  useOnPathChange(useCallback(() => setSideNavOpen?.(false), [setSideNavOpen]));

  return null;
}
